import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import pandit from "../../assets/images/new/fav-removebg-preview.png";
import { LoaderContext } from '../../AuthContext/AuthContext';
import { t } from 'i18next';
import { GetPopularPujaAPI } from '../../ApiServices/BookPanditAPI/BookPanditAPI';
import { GetPopularDailyPujaAPI } from '../../ApiServices/DailyPanditAPI/DailyPanditApi';
import { GetPopolarPujaList } from '../../ApiServices/Puja/PujaApi';
import OwlCarousel from "react-owl-carousel3";

const PopularPujas = ({ pujaListData }) => {
    const navigate = useNavigate()
    const { servicename } = useParams();
  
    const { setLoader, selectedLanguageID, formatToIndianCurrency } = useContext(LoaderContext);
    const [totalRecords, setTotalRecords] = useState(-1);


    const options = {
        loop: pujaListData.length > 3,
        rewind: true,
        margin: 30,
        nav: true,
        dots: false,
        autoplay: false,
        autoplayTimeout: 3000,
        smartSpeed: 1000,
        lazyLoad: true, // ✅ important for performance
        navText: [
            "<i class='fas fa-arrow-left'></i>",
            "<i class='fas fa-arrow-right'></i>",
        ],
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2,
            },
            1000: {
                items: 4,
            },
        },
    };

 

    const handleNavigation = (slug) => {
        navigate(`/service/puja-details/${slug}`, { replace: true });
        window.scrollTo({ top: 0, behavior: "instant" }); // Instantly move to the top without scroll animation

    };

    return (
        <>
         
                <section
                    data-aos="fade-up"
                    data-aos-duration="1000"
                    className="service-one"
                    style={{ padding: "30px 0", background: "white" }}
                >
                    <div
                        className="container"
                        style={{ display: "flex", flexDirection: "column", cursor: "pointer" }}
                    >
                        <div className="row">
                            <div className="col-12">
                                <div className="section-title text-center">
                                    <h6
                                        className="sec-title__tagline bw-split-in-right"
                                        style={{
                                            perspective: "400px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <img className="tagline-img" src={pandit} alt="" />
                                        {servicename === "daily-puja-booking"
                                            ? t("Popular Daily Pujas")
                                            : t("Popular Pujas")}
                                    </h6>
                                    <h3
                                        className="sec-title__title bw-split-in-left"
                                        style={{ perspective: "400px", textAlign: "center" }}
                                    >
                                        {t("Sacred rituals trusted by devotees worldwide.")}
                                    </h3>
                                </div>

                                <OwlCarousel className="owl-theme" {...options}>
                                    {pujaListData && pujaListData.length > 0 ? (
                                        pujaListData.map((item, index) =>
                                            item && item.pujaImageUrl ? (
                                                <div key={item.ROW || index} onClick={() => handleNavigation(item.pujaSlug)}>
                                                    <div
                                                        className="card-custom"
                                                        style={{ height: "350px" }}
                                                    >
                                                        <div className="card-custom__header">
                                                            <img
                                                                src={item.pujaImageUrl}
                                                                alt={item.pujaName}
                                                                style={{ objectFit: "fill" }}
                                                                className="card-custom__image"
                                                            />
                                                        </div>
                                                        <div className="card-popular-puja-custom__body">
                                                            <h4 className="service-two__item__title">
                                                                {item.pujaName}
                                                            </h4>
                                                            <div className="mt-auto">
                                                                <span
                                                                    className="fw-bold d-block mb-2"
                                                                    style={{ fontSize: "16px", color: "#000" }}
                                                                >
                                                                    ₹
                                                                    {item.onlinePujaPrice
                                                                        ? formatToIndianCurrency(
                                                                            Math.round(
                                                                                item.onlinePujaPrice -
                                                                                (item.onlinePujaDiscountAmount || 0)
                                                                            )
                                                                        )
                                                                        : formatToIndianCurrency(
                                                                            Math.round(
                                                                                item.offlinePujaPrice -
                                                                                (item.offlinePujaDiscountAmount || 0)
                                                                            )
                                                                        )}
                                                                </span>


                                                            </div>
                                                        </div>
                                                        <div
                                                            className="service-two__item__rm"
                                                            onClick={() => handleNavigation(item.pujaSlug)}
                                                        >
                                                            <span style={{ color: "#a52444" }}> {t("Book Puja Now")}</span>
                                                            <i className="icon-right-arrow"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : null
                                        )
                                    ) : totalRecords < 0 ? (
                                        <p className="text-center d-flex justify-content-center fw-bold">{t("Loading...")}</p>
                                    ) : (<p className="text-center d-flex justify-content-center fw-bold">{t("No Pujas available")}</p>)}
                                </OwlCarousel>


                            </div>
                        </div>
                    </div>
                </section>
            

        </>
    )
}

export default PopularPujas
